/*
 * Copyright Huesik (c) 2019.
 */

import MenuConstants from './menu'

export const CONSTANTS = {
  MENU: MenuConstants
}

